import { Link } from "react-router-dom";

export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 40 40" className={className} aria-hidden="true">
    <defs>
      <linearGradient id="bv-g" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#0284C7" />
        <stop offset="1" stopColor="#0D9488" />
      </linearGradient>
    </defs>
    <rect width="40" height="40" rx="12" fill="url(#bv-g)" />
    <path d="M13 10h8.5a5.5 5.5 0 0 1 3.4 9.8A6 6 0 0 1 22 31h-9V10z" fill="none" stroke="#fff" strokeWidth="3" strokeLinejoin="round" />
    <path d="M17 21.5l2.6 2.6 5-5.2" fill="none" stroke="#fff" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default function Logo({ light = false }) {
  return (
    <Link to="/" data-testid="logo-link" className="flex items-center gap-2.5">
      <LogoMark />
      <span className={`font-heading text-xl font-bold tracking-tight ${light ? "text-white" : "text-slate-900"}`}>
        Book<span className="text-sky-600">vera</span>
      </span>
    </Link>
  );
}
